import '@github/file-attachment-element';
import 'fomantic-ui-less/definitions/modules/transition';
import 'fomantic-ui-less/definitions/modules/search';
import {suggestionsPlugin, triggerCharacter} from './suggestionsPlugin';

const applyCommand = function (view, range, action) {
    if (view.composing) {
      return;
    }

    const state = view.state;
    const tr = state.tr;
    const {from, to} = range;

    tr.replaceWith(from, to, '');
    view.dispatch(tr);

    action();

    view.focus();
}

const showCommandList = function (view, range, text, commands) {
    let commandList = document.getElementById('command-tooltip');
    if (!commandList) {
        commandList = document.createElement("div");
        commandList.id = 'command-tooltip';
        commandList.className = 'ui search tiny active focus scrolling';
        commandList.innerHTML = '<input class="prompt" type="text" style="display: none"><div class="results"></div>';

        view.dom.parentNode.appendChild(commandList);
    }

    let commandSource;
    if (commands instanceof Function) {
        commandSource = commands(text);
    } else {
        commandSource = Promise.resolve(commands.filter(command => !command.disabled || !command.disabled()));
    }

    commandSource.then(source =>
        $(commandList).search({
            source,
            fullTextSearch: true,
            showNoResults: false,
            maxResults: source.length,
            type: 'category',
            transition: 'scale',
            duration: 0,
            searchFields: [
                'title',
                'description',
                'category',
                'keywords'
            ],
            onSelect: result => applyCommand(view, range, result.action)
        }).search('search local', text)
    )

    const {from} = range;
    const start = view.coordsAtPos(from);
    const {left: boxLeft, bottom: boxBottom} = commandList.offsetParent.getBoundingClientRect();

    commandList.style.left = start.left - boxLeft + "px";
    commandList.style.bottom = (boxBottom - start.bottom) + "px";
}

const trigger = (char, { allowSpaces = false }) => {
  return $position => {
    // Matching expressions used for later
    const suffix = new RegExp(`\\s${char}$`);
    const regexp = allowSpaces
        ? new RegExp(`${char}.*?(?=\\s${char}|$)`, 'g')
        : new RegExp(`(?:^)?${char}[^\\s${char}]*`, 'g');

    // Lookup the boundaries of the current node
    const textFrom = $position.before();
    const textTo = $position.end();

    const text = $position.doc.textBetween(textFrom, textTo, '\0', '\0');
    const blocks = text.split('\0');
    const lastBlock = blocks.pop();

    let match;
    while (match = regexp.exec(lastBlock)) {
      // Javascript doesn't have lookbehinds; this hacks a check that first character is " " or the line beginning
      const prefix = match.input.slice(Math.max(0, match.index - 1), match.index);
      if (!/^[\s\0]?$/.test(prefix)) {
        continue;
      }

      // The absolute position of the match in the document
      let from = match.index + $position.start();
      let to = from + match[0].length;

      blocks.forEach(block => {
        from += block.length + 1;
        to += block.length + 1;
      });

      // Edge case handling; if spaces are allowed and we're directly in between two triggers
      if (allowSpaces && suffix.test(lastBlock.slice(to - 1, to + 1))) {
        match[0] += ' ';
        to++;
      }

      // If the $position is located within the matched substring, return that range
      if (from < $position.pos && to >= $position.pos) {
        return { range: { from: from, to }, text: match[0] };
      }
    }
  }
}

export const slashCommandTrigger = () => {
    return $position => {
        const parent = $position.parent;
        if (parent && ['page_title', 'code_block'].includes(parent.type.name)) {
            return;
        }

      try {
        return trigger("/", {allowSpaces: true})($position);
      } catch (e) {}
    }
}

export const atCommandTrigger = function () {
    return $position => {
        const parent = $position.parent;
        if (parent && ['code_block'].includes(parent.type.name)) {
            return;
        }

        try {
            return triggerCharacter('@', {allowSpaces: true})($position);
        } catch (e) {}
    }
}

export const commandSuggestions = (matcher, commands) => suggestionsPlugin({
    matcher,
    onEnter({view, range, text}) {
        showCommandList(view, range, text.slice(1), commands);
        return true;
    },
    onChange({view, range, text}) {
        showCommandList(view, range, text.slice(1), commands);
        return true;
    },
    onExit() {
        const $commandTooltip = $('#command-tooltip');
        if ($commandTooltip.search('is visible')) {
            const keyEvent = $.Event('keydown');
            keyEvent.which = 27;
            $commandTooltip.find('input').trigger(keyEvent);
            return true;
        }
        return false;
    },
    onKeyDown({view, event}) {
        if (event.key === "Backspace") {
          setTimeout(() => {
            const $position = view.state.selection.$from;
            const match = matcher($position);
            if (match) {
              showCommandList(view, match.range, match.text.slice(1), commands);
            }
            return null;
          });
        }

        const $commandTooltip = $('#command-tooltip');
        if ($commandTooltip.search('is visible') && ['Tab', 'PageUp', 'PageDown', 'Escape', 'ArrowUp', 'ArrowDown', 'Enter'].includes(event.key)) {
            const keyEvent = $.Event('keydown');
            keyEvent.which = event.keyCode;
            $commandTooltip.find('input').trigger(keyEvent);
            return true;
        }
        return false;
    }
});